import React from "react";
import "./UserBasicDetails.css";
import Sidebar from "../../Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import SingingContract from "../../../../assests/SingingContract.svg";
import Avatar from "../../../../assests/Avatar.png"; // Make sure to import Avatar
import { useNavigate } from "react-router-dom";
import {
  Button,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select
} from "@mui/material";

const UserBasicDetailsComponent = (props) => {
  const navigate = useNavigate();
  const handleClick = () => navigate(-1);

  const getImageUrl = (imagePath) => {
    if (!imagePath || imagePath === "null" || imagePath === "undefined") {
      return null;
    }
    
    // Remove any query parameters if present
    const cleanPath = imagePath.split('?')[0];
    
    // Check if the path already contains the full URL
    if (cleanPath.startsWith('http')) {
      return cleanPath;
    }
    
    // Remove "product/" prefix if it exists (to avoid duplication)
    const pathWithoutProductPrefix = cleanPath.startsWith('product/') 
      ? cleanPath.substring('product/'.length) 
      : cleanPath;
    
    // Construct the correct S3 URL with product/public prefix
    return `https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/product/${pathWithoutProductPrefix}`;
  };

  // Get the image URL from props.basicdetails
  const imageUrl = props.basicdetails?.imageUrl ? getImageUrl(props.basicdetails.imageUrl) : null;

  return (
    <div className="user-basic-details-container-update">
      <Sidebar />

      <div className="user-details-main-content-update">
        <div className="user-details-header-update">
          <button onClick={handleClick} className="back-button-update">
            <img src={leftArrow} alt="Go back" className="back-icon-update" />
          </button>
          <h1 className="page-title-update">Basic Details</h1>
        </div>

        <div className="user-details-scroll-area">
          <div className="user-details-content-update">
            {/* Left: Form */}
            <div className="user-form-section-update">
              <div className="form-field-group-update">
                <h3 className="field-group-title-update">User Status</h3>
                <div className="status-toggle-group-update">
                  <button
                    onClick={props?.handleButtonsUpdate}
                    value="active"
                    className={`status-button-update ${props.userStatus === "active" ? "active" : ""}`}
                  >
                    Active
                  </button>
                  <button
                    onClick={props?.handleButtonsUpdate}
                    value="deleted"
                    className={`status-button-update ${props.userStatus !== "active" ? "deleted" : ""}`}
                  >
                    Inactive
                  </button>
                </div>
              </div>

              <div className="form-field-group-update">
                <h3 className="field-group-title-update">User Verification</h3>
                <div className="status-toggle-group-update">
                  <button
                    onClick={props?.handleButtonsVerification}
                    value="verified"
                    className={`status-button-update ${props.userVerifiedStatus === "verified" ? "verified" : ""}`}
                  >
                    Verified
                  </button>
                  <button
                    onClick={props?.handleButtonsVerification}
                    value="unverified"
                    className={`status-button-update ${props.userVerifiedStatus !== "verified" ? "unverified" : ""}`}
                  >
                    Unverified
                  </button>
                </div>
              </div>

              <TextField
                fullWidth
                label="Full Name"
                variant="outlined"
                value={props.userName}
                onChange={props.handleUpdateUserName}
                margin="normal"
              />

              <TextField
                fullWidth
                label="Employee Code"
                variant="outlined"
                value={props.userEmployeeCode}
                onChange={props.handleUpdateUserEmployeeCode}
                margin="normal"
              />

              <FormControl fullWidth margin="normal">
                <InputLabel id="select-role-label">Role</InputLabel>
                <Select
                  labelId="select-role-label"
                  value={props.userRole || ""}
                  label="Role"
                  onChange={(e) => props.handleUpdateUserRole(parseInt(e.target.value))}
                  disabled={!props.isAdmin}
                >
                  {props.basicRole?.map((el) => (
                    <MenuItem key={el.id} value={el.id}>
                      {el.name}
                    </MenuItem>
                  ))}
                </Select>
                {!props.isAdmin && (
                  <p className="role-change-warning">
                    Only Admin can change roles
                  </p>
                )}
              </FormControl>

              <TextField
                fullWidth
                label="Email ID"
                variant="outlined"
                value={props.userEmail}
                onChange={props.handleUpdateUserEmail}
                margin="normal"
              />

              <div className="form-actions-update">
                <Button variant="outlined" onClick={handleClick}>
                  Back
                </Button>
                <Button variant="contained" onClick={props.UpdateUserApi}>
                  Save
                </Button>
              </div>
            </div>

            {/* Right: Image Display */}
            <div className="illustration-section-update">
              <div className="user-image-container-update">
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={props.basicdetails?.full_name || "User"}
                    className="user-main-image-update"
                    onError={(e) => {
                      console.error("Image failed to load, showing fallback avatar");
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                    loading="lazy"
                  />
                ) : null}
                <div
                  className="user-image-placeholder-update"
                  style={{ display: imageUrl ? "none" : "flex" }}
                >
                 <img src={SingingContract} alt="Illustration" className="illustration-image-update" />

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBasicDetailsComponent;